import { assertUnreachable } from 'lib/staticAssert/staticAssertUtils'
import type {
  AssistantSurfaceContextRequest,
  AssistantSurfaceContextSnapshot,
  AssistantSurfaceId,
} from 'tripPlanner/assistant/api/types'

interface BuildAssistantSurfaceContextSnapshotArgs {
  surface: AssistantSurfaceId
  buildSurfaceContext?: () => AssistantSurfaceContextRequest
}

export function buildAssistantSurfaceContextSnapshot({
  surface,
  buildSurfaceContext,
}: BuildAssistantSurfaceContextSnapshotArgs): AssistantSurfaceContextSnapshot {
  switch (surface) {
    case 'trip_planner':
      return { surface }
    case 'accommodation_offer_page': {
      if (!buildSurfaceContext) {
        throw new Error('Page-aware assistant surfaces require surface context')
      }

      const surfaceContext = buildSurfaceContext()
      return {
        surface,
        surfaceContext,
      }
    }
    default:
      return assertUnreachable(surface)
  }
}
